import React from "react";

function Trending() {
  return (
    <>
      <div className="w-full bg-green-">
        <div className="w-full md:w-10/12 lg:w-7/12 bg-red- mx-auto flex flex-row p-2 md:p-6 items-center">
          {/* BLOCK */}
          <div className="uppercase text-xs-s md:text-xs bg-black text-white p-1.5 font-medium tracking-wide	">
            Trending Now
          </div>
          {/* NEWS TEXT */}
          <div className="px-5 italic text-sm">
            lorem ipsum shit lorem ipsum shit lorem ipsum shit lorem ipsum shit
          </div>
        </div>
      </div>
    </>
  );
}

export default Trending;
